// test2042
(2042 && 0);
